/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

// IconRegistry.registerIcon("dataexplorer.solution", require("./rawicons/dataexplorer.svg.js"));
IconRegistry.registerIcon("dataexplorer.add", require("./rawicons/add.svg.js"));
IconRegistry.registerIcon("dataexplorer.edit", require("./rawicons/edit.svg.js"));
IconRegistry.registerIcon("dataexplorer.detailed", require("./rawicons/detailed.svg.js"));
IconRegistry.registerIcon("dataexplorer.run", require("./rawicons/run.svg.js"));
